import React from 'react';
import BasicDetails from '../components/BasicDetails';
import NomineeDetails from '../components/NomineeDetails';
import HealthDeclaration from '../components/HealthDeclaration';
import Attachments from '../components/Attachments';
import Success from '../components/Success';
import ProgressBar from '../components/ProgressBar';
import { BasicDetailsModel } from '../models/BasicDetails';
import { NomineeDetailsModel } from '../models/NomineeDetails';
import { HealthDeclarationModel } from '../models/HealthDeclaration';
import { AttachmentsModel } from '../models/Attachments';
import '../styles/main.scss';
import { RegistrationState } from '../models/RegistrationState';
import { generateRegistrationPDF } from '../utils/pdfGenerator';
import { submitRegistration } from '../services/apiService';

class Registration extends React.Component<{}, RegistrationState & { isLoading: boolean; uploadProgress: number; error: string | null; registrationId: number | null }> {
  constructor(props: {}) {
    super(props);
    const savedData = localStorage.getItem('psk_registration_data');
    if (savedData) {
      try {
        this.state = { ...JSON.parse(savedData), isLoading: false, uploadProgress: 0, error: null, registrationId: null };
      } catch (e) {
        this.state = { step: 1, isLoading: false, uploadProgress: 0, error: null, registrationId: null };
      }
    } else {
      this.state = { step: 1, isLoading: false, uploadProgress: 0, error: null, registrationId: null };
    }
  }

  componentDidUpdate() {
    localStorage.setItem('psk_registration_data', JSON.stringify(this.state));
  }

  handleBasicSubmit = (data: BasicDetailsModel) => {
    this.setState({ basicDetails: data, step: 2 });
  };

  handleNomineeSubmit = (data: NomineeDetailsModel) => {
    this.setState({ nomineeDetails: data, step: 3 });
  };

  handleHealthSubmit = (data: HealthDeclarationModel) => {
    this.setState({ healthDeclaration: data, step: 4 });
  };

  handleAttachmentsSubmit = (data: AttachmentsModel) => {
    const { basicDetails, nomineeDetails, healthDeclaration } = this.state;

    this.setState({ attachments: data, isLoading: true, uploadProgress: 0, error: null });

    submitRegistration(
      { basicDetails, nomineeDetails, healthDeclaration },
      data as any,
      (progress: number) => {
        this.setState({ uploadProgress: progress });
      }
    )
      .then((json: any) => {
        this.setState({ step: 5, isLoading: false, registrationId: json.registration_id });
        if (basicDetails && nomineeDetails && healthDeclaration) {
          generateRegistrationPDF(basicDetails, nomineeDetails, healthDeclaration);
        }
      })
      .catch((err: Error) => {
        console.error('Upload error', err);
        this.setState({ isLoading: false, error: err.message });
      });
  };

  handleReset = () => {
    this.setState({
      step: 1,
      basicDetails: undefined,
      nomineeDetails: undefined,
      healthDeclaration: undefined,
      attachments: undefined
    });
  };

  handleBack = () => {
    this.setState(prevState => ({ step: prevState.step - 1 }));
  };

  render() {
    const { step, basicDetails, nomineeDetails, healthDeclaration, attachments } = this.state;

    return (
      <div className="main-container">
        {step < 5 && (
          <div className="registration-header">
            <h1 className="page-title">વીમા નોંધણી</h1>
            <ProgressBar currentStep={step} steps={['મૂળભૂત', 'વારસદાર', 'આરોગ્ય', 'સંલગ્નક']} />
          </div>
        )}

        {step === 1 && (
          <BasicDetails
            data={basicDetails}
            onSubmit={this.handleBasicSubmit}
          />
        )}

        {step === 2 && (
          <NomineeDetails
            data={nomineeDetails}
            basicDetails={basicDetails}
            onSubmit={this.handleNomineeSubmit}
            onBack={this.handleBack}
          />
        )}

        {step === 3 && (
          <HealthDeclaration
            data={healthDeclaration}
            onSubmit={this.handleHealthSubmit}
            onBack={this.handleBack}
          />
        )}

        {step === 4 && (
          <Attachments
            data={attachments}
            onSubmit={this.handleAttachmentsSubmit}
            onBack={this.handleBack}
          />
        )}

        {(this.state as any).isLoading && (
          <div className="loading-overlay">
            <div className="loading-modal">
              <h3 className="loading-title">સબમિશન ચાલુ છે...</h3>
              <p className="loading-subtitle">કૃપા કરીને રાહ જોો...</p>
              <div className="progress-bar-container">
                <div className="progress-bar-fill" style={{ width: (this.state as any).uploadProgress + '%' }} />
              </div>
              <p className="progress-text">{(this.state as any).uploadProgress}% અપલોડ થયું</p>
            </div>
          </div>
        )}

        {(this.state as any).error && (
          <div className="error-toast">
            <p className="error-title">ભૂલ</p>
            <p className="error-message">{(this.state as any).error}</p>
            <button onClick={() => this.setState({ error: null })} className="error-close-btn">બંધ કરો</button>
          </div>
        )}

        {step === 5 && (
          <Success onReset={this.handleReset} />
        )}
      </div>
    );
  }
}

export default Registration;